var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVendorsWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 43.61153 74.27698",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.07612,26.6929l-19.26-20.78709V2.01011a2.01012,2.01012,0,0,0-4.02023,0V5.90532L.53541,26.6929A2.01161,2.01161,0,0,0,0,28.05915v7.0197A2.01039,2.01039,0,0,0,3.48482,36.4451l.87893-.94862V70.25676H3.76111a2.01011,2.01011,0,0,0,0,4.02022h36.0893a2.01011,2.01011,0,1,0,0-4.02022h-.60264V35.49648l.87894.94862a2.01039,2.01039,0,0,0,3.48482-1.36625v-7.0197A2.01165,2.01165,0,0,0,43.07612,26.6929ZM8.384,31.15763,14.65185,24.393V35.04744H12.46948a2.01021,2.01021,0,0,0-2.01011,2.01011V59.5727a2.01021,2.01021,0,0,0,2.01011,2.01011h2.18237v8.67395H8.384ZM24.93945,61.58281v8.67395H18.67208V61.58281ZM14.47959,57.56258V39.06767H29.13193V57.56258Zm4.19249-22.51514V20.05409L21.806,16.67178l3.13344,3.38188V35.04744ZM35.22755,70.25676H28.95968V61.58281h2.18237a2.01022,2.01022,0,0,0,2.01011-2.01011V37.05755a2.01022,2.01022,0,0,0-2.01011-2.01011H28.95968V24.39263l6.26787,6.76488Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendorsWhite);
export default __webpack_public_path__ + "static/media/Vendors_White.8dfc9e9e3b395e970bed9c652c76302d.svg";
export { ForwardRef as ReactComponent };